const toNum = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : null;
};

/**
 * Returns active discounts only, normalized for UI rendering.
 * - filters by isActive === true
 * - computes `computedLinePrice` from `price` or `unitPrice * quantity.amount`
 * - never throws on malformed input
 */
export const getActiveDiscounts = (order) => {
  const raw = order?.discount;
  if (!Array.isArray(raw)) return [];

  return raw
    .filter((d) => d && typeof d === "object" && d.isActive === true)
    .map((d, idx) => {
      const qty = toNum(d?.quantity?.amount) ?? 1;
      const unitPrice = toNum(d?.unitPrice);
      const price = toNum(d?.price);
      const computedLinePrice = price != null ? price : (unitPrice != null ? unitPrice * qty : null);

      return {
        key: String(d?.code || d?.name || idx),
        isActive: true,
        name: typeof d?.name === "string" && d.name.trim() ? d.name.trim() : "",
        code: typeof d?.code === "string" && d.code.trim() ? d.code.trim() : "",
        type: typeof d?.type === "string" && d.type.trim() ? d.type.trim() : "",
        value: toNum(d?.value),
        vatRate: toNum(d?.vatRate),
        computedLinePrice,
        raw: d,
      };
    });
};

export const formatDiscountType = (t, type) => {
  const normalized = String(type || "").trim().toLowerCase();
  if (normalized === "amount") {
    return t("pages.dsokOrders.discount.types.amount", { defaultValue: "Amount" });
  }
  if (normalized === "percent") {
    return t("pages.dsokOrders.discount.types.percent", { defaultValue: "Percent" });
  }
  return normalized
    ? t("pages.dsokOrders.discount.types.unknown", { defaultValue: normalized })
    : "—";
};

